import { InfoCircleOutlined } from '@ant-design/icons'
import { Col, Row, Space, Tooltip, Typography } from 'antd'
import React, { useEffect } from 'react'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { useFetchAsanSignMutation } from 'store/reducers/ibsigning/asansigning/sign/signApi'
import { useFetchVerifyAsanSignMutation } from 'store/reducers/ibsigning/asansigning/verify/verifyApi'
import asanLogo from 'assets/images/icons/asan-logo.png'
import styles from './AsanSigning.module.scss'
import { useCustomModal } from '@shared/Modal'
import { t } from 'i18next'

interface SingModalContentProps {
  asanKey: React.Key
}

const timer = ({ remainingTime }) => {
  const minutes = Math.floor(remainingTime / 60)
  const seconds = remainingTime % 60

  return `${minutes > 9 ? minutes : `0${minutes}`}:${
    seconds > 9 ? seconds : `0${seconds}`
  }`
}

export default function SignModalContent({ asanKey }: SingModalContentProps) {
  const { setStatus } = useCustomModal()

  const [
    _1,
    {
      error: verifyError,
      status: verifyStatus,
      isLoading: isVsLoading,
      isError: isVsError,
    },
  ] = useFetchVerifyAsanSignMutation({ fixedCacheKey: `${asanKey}_fetchVerifyAsanSign` })

  const [_, { data, isSuccess }] = useFetchAsanSignMutation({
    fixedCacheKey: `${asanKey}_fetchAsanSign`,
  })

  // useEffect(() => {
  //   if (isSuccess) {
  //     fetchVerifyAsanSign({
  //       transactionId: data.transactionId,
  //     })
  //   }
  // }, [isSuccess])

  // useEffect(() => {
  //   if(isVsError) {
  //     setStatus({ status: verifyStatus, message: verifyError?.data ?? '' })
  //   }
  // }, [isVsError])

  return (
    !isVsLoading ? <></> : <Row
      className={styles['asan-signing-modal']}
      justify="space-between"
      align="middle"
      style={{ flexDirection: 'column', height: '100%', gap: 30 }}
    >
      <Col style={{ width: '100%' }}>
        <Row align="middle" justify="space-between">
          <Col>
            <img src={asanLogo} />
          </Col>
          <Col>
            <Tooltip title="Title">
              <InfoCircleOutlined style={{ cursor: 'pointer' }} />
            </Tooltip>
          </Col>
        </Row>
      </Col>
      <Col>
        <Typography.Text
          color="#015CD1"
          style={{ textAlign: 'center', fontSize: 16 }}
        >
         {t('orders.asanOtpSure')}
        </Typography.Text>
      </Col>
      <Col>
        <Space direction="vertical" align="center">
          <Typography.Text className="verifytext">{t('orders.checkCode')}</Typography.Text>
          <Typography.Text className="verifycode">
            {data?.verificationCode}
          </Typography.Text>
        </Space>
      </Col>
      <Col>
        <CountdownCircleTimer
          isPlaying={isVsLoading}
          duration={120}
          size={80}
          strokeWidth={3}
          colors="#015cd1"
        >
          {timer}
        </CountdownCircleTimer>
      </Col>
    </Row>
  )
}
